import { Injectable, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FsTicketsAuthService {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  /**
   * Forces a refresh of the BFG session and returns the new access token,
   * or null when the refresh fails (the BFG session is over).
   */
  refreshAccessToken(): Observable<string | null> {
    return this.oidcSecurityService.forceRefreshSession().pipe(
      map(result => (result?.isAuthenticated && result.accessToken) || null),
      catchError(() => of(null))
    );
  }
}
